import { render, staticRenderFns } from "./MesaCard.vue?vue&type=template&id=45ab3f2a"
import script from "./MesaCard.vue?vue&type=script&lang=js"
export * from "./MesaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports